import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let supabase: SupabaseClient | null = null;
let configPromise: Promise<{ supabaseUrl: string; supabaseAnonKey: string }> | null = null;

async function getConfig() {
  if (!configPromise) {
    configPromise = fetch("/api/config")
      .then((res) => res.json())
      .catch((err) => {
        console.error("Failed to fetch config:", err);
        throw err;
      });
  }
  return configPromise;
}

export async function getSupabase(): Promise<SupabaseClient> {
  if (supabase) return supabase;
  const config = await getConfig();
  supabase = createClient(config.supabaseUrl, config.supabaseAnonKey);
  return supabase;
}

// Export supabase instance for client feature compatibility
export { supabase };

export function getToken(): string | null {
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith("sb-") && key.endsWith("-auth-token")) {
      const session = JSON.parse(localStorage.getItem(key) || "null");
      if (session?.access_token) return session.access_token;
    }
  }
  return null;
}
